import { North } from "@mui/icons-material";
import { IconButton, InputBase, Paper } from "@mui/material";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { ObjectId } from "../../interfaces/common";

interface ChatInputProps {
  chatId: ObjectId;
  loading: boolean;
  sendMessage: Function;
}

const ChatInput: React.FC<ChatInputProps> = ({
  chatId,
  loading,
  sendMessage,
}) => {
  const [userInput, setUserInput] = useState<string>("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    setUserInput("");
  }, [chatId]);

  useEffect(() => {
    if (textareaRef.current) {
      const textareaElement = textareaRef.current;
      textareaElement.style.height = "auto";
      textareaElement.style.height = `${textareaElement.scrollHeight}px`;
    }
  }, [userInput]);

  const handleSendMessage = async (userInput: string) => {
    setUserInput("");
    await sendMessage(userInput);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter") {
      if (!e.shiftKey) {
        e.preventDefault();
        if (userInput) {
          handleSendMessage(userInput);
        }
      } else {
        e.preventDefault();
        const textarea = e.target as HTMLTextAreaElement;
        const { selectionStart, selectionEnd } = textarea;

        setUserInput((prevInput) => {
          return (
            prevInput.slice(0, selectionStart) +
            "\n" +
            prevInput.slice(selectionEnd)
          );
        });

        setTimeout(() => {
          textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
        }, 0);
      }
    }
  };

  return (
    <Paper className="flex-col rounded-xl border-solid border-slate-200 shadow-[0_9px_9px_0px_rgba(0,0,0,0.06),_0_2px_5px_0px_rgba(0,0,0,0.06)]">
      <InputBase
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        placeholder="Envoyer un message..."
        inputProps={{ "aria-label": "Envoyer un message" }}
        onKeyDown={handleKeyDown}
        className="flex-1 pt-4 px-4"
        multiline
        minRows={2}
        fullWidth
      />
      <div className="flex items-center justify-end p-2">
        <IconButton
          onClick={() => handleSendMessage(userInput)}
          disabled={!userInput || loading}
          className={classNames({
            "bg-[--mui-palette-primary-main]": !!userInput,
            invisible: !userInput,
          })}
          size="small"
        >
          <North className="text-white" />
        </IconButton>
      </div>
    </Paper>
  );
};

export default ChatInput;
